import {PartialPolicy, Policy} from "../models/policy.model";
import axios, { AxiosResponse } from "axios";
import { IUtm } from "../models/utm.interface";

export const policyService = {
  createPolicy: (partialPolicy: PartialPolicy, utm: IUtm): Promise<AxiosResponse<any>> => {
    partialPolicy.tracking = utm;
    console.log("Calling createPolicy endpoint");
    console.log(JSON.stringify(partialPolicy));
    
    return axios.post(`/policy/create`, JSON.stringify(partialPolicy), {
      headers: { "content-type": "application/json" },
      withCredentials: true
    });
    
  },

  finalisePolicy: (policy: Policy, utm: IUtm): Promise<AxiosResponse<any>> => {
    policy.tracking = utm;
    //console.log(JSON.stringify(policy));

    return axios.post(`/policy/finalise`, JSON.stringify(policy), {
      headers: { "content-type": "application/json" },
      withCredentials: true
    });
  }
};
